import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Alert, Row, Col, ListGroup } from 'react-bootstrap';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import emsLogo from '../img/ems.png';

const PacientCard = () => {
    const [query, setQuery] = useState('');
    const [data, setData] = useState(null);
    const [info, setInfo] = useState('');
    const [status, setStatus] = useState(null);
    const [suggestions, setSuggestions] = useState([]);
    const [allPatients, setAllPatients] = useState([]);

    const removeDiacritics = (text) => {
        return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    const downloadPDF = async (data) => {
        const doc = new jsPDF();

        // Logo úplně nahoře
        doc.addImage(emsLogo, 'PNG', 80, 10, 50, 50);

        const contentStartY = 70;
        const name = removeDiacritics(data.name || 'Nezname jmeno');
        const death = data.history?.some(item => removeDiacritics(item.typ) === "Umrti (CK)");

        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text('Karta pacienta', 20, contentStartY);

        doc.setFontSize(13);
        doc.setFont('helvetica', 'normal');
        doc.text(`Jmeno: ${name}`, 20, contentStartY + 10);

        if (death) {
            doc.setTextColor(200, 0, 0);
            doc.text('Pacient je evidovan jako mrtvy', 20, contentStartY + 20);
            doc.setTextColor(0, 0, 0);
        }

        const history = data.history.map(item => ([
            removeDiacritics(item.dt),
            removeDiacritics(item.typ),
            removeDiacritics(item.location),
            removeDiacritics(item.details)
        ]));

        autoTable(doc, {
            startY: contentStartY + (death ? 30 : 20),
            head: [["Datum", "Typ", "Lokalita", "Detail zasahu"]],
            body: history,
            styles: { fontSize: 11 },
            headStyles: { fillColor: [33, 150, 243] },
            margin: { left: 20, right: 20 }
        });

        doc.save(`${name.replaceAll(' ', '_')}_karta_pacienta.pdf`);
    };


    useEffect(() => {
        fetch('https://ems.lexikonn.eu/api/pacient_names.php')
            .then(res => res.json())
            .then(setAllPatients);
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        fetch(`https://ems.lexikonn.eu/api/pacient_card.php?name=${encodeURIComponent(query)}`)
            .then(res => res.json())
            .then(setData);
    };

    const handleSuggestionClick = (name) => {
        setQuery(name);
        setSuggestions([]);
        fetch(`https://ems.lexikonn.eu/api/pacient_card.php?name=${encodeURIComponent(name)}`)
            .then(res => res.json())
            .then(setData);
    };

    return (
        <div className="container py-5">
            <h2 className="mb-4">🩺 Karta pacienta</h2>

            <Form onSubmit={handleSearch} className="mb-4">
                <Row>
                    <Col md={12} className="position-relative">
                        <Form.Control
                            type="text"
                            placeholder="Zadej jméno pacienta"
                            value={query}
                            onChange={(e) => {
                                const value = e.target.value;
                                setQuery(value);

                                const filtered = allPatients.filter(p =>
                                    p.toLowerCase().includes(value.toLowerCase()) && value.length > 1
                                );
                                setSuggestions(filtered);
                            }}
                            autoComplete="off"
                        />
                        {suggestions.length > 0 && (
                            <ListGroup className="position-absolute w-100 z-3" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                {suggestions.map((s, i) => (
                                    <ListGroup.Item key={i} action onClick={() => handleSuggestionClick(s)}>
                                        {s}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        )}
                    </Col>
                </Row>
            </Form>

            {data && (
                <Card className="mb-4 shadow">
                    <Card.Body>
                        <h4>
                            {data.name}
                            {data.history?.some(item => item.typ === "Úmrtí (CK)") && (
                                <span className="badge bg-danger ms-2">Pacient zemřel</span>
                            )}
                        </h4>

                        <h5 className="mt-4">📄 Historie zdravotní péče</h5>
                        <Button variant="outline-danger" size="sm" onClick={() => downloadPDF(data)} className="mb-3">
                        📄 Stáhnout PDF
                        </Button>

                        <ul>
                            {data.history.map((item, index) => (
                                <li key={index}>{item.dt} – <b>{item.typ}</b> ({item.location}) |
                                    Záznam: <b>{item.details}</b></li>
                            ))}
                        </ul>
                    </Card.Body>
                </Card>
            )}
        </div>
    );
};

export default PacientCard;